import React from 'react';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import ResidentialStatus from './ResidentialStatus';

const ResidentialAdress = (props) => {
  const {
    values,
    data,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFieldTouched,
    handleSubmit
  } = props;



  return (
    <>

      <div className="w-full  md:bg-white py-5 bg-blue-1210 px-5">
        <div className="bg-blue-1200 md:bg-white w-full  h-full py-10  shadow md:shadow-none">
          {!values.currentAddress || values.currentAddress=='no'? 

         <>

          <div className="w-full md:px-10  px-4">
            <p className="font-roboto font-normal text-black-920 text-sm ">
              Address
            </p>

            <div className="bg-grey-900 md:bg-grey-0 py-3 w-12/12 md:w-8/12 lg:w-7/12 xl:w-8/12 mr-auto my-3 border border-navy-200 h-full py-1 px-2 rounded-lg flex pb-10">
              <div className="w-1/12 ">
                <LocationOnOutlinedIcon
                  style={{ color: 'grey', width: '25px', height: '25px' }}
                />
              </div>
              <div className="w-8/12 text-left px-3">
                <p className="font-roboto font-normal text-grey-1200 text-sm mr-auto">
                  Address 1
                </p>
                <p className="font-roboto font-normal text-black-400 text-xs py-1">
                  {values.address}
                </p>
              </div>
              <div className="w-5/12 items-start ml-auto text-right">
                <p
                  className="font-roboto font-normal text-black-400 text-xs  ml-auto"
                  style={{ fontSize: '10px' }}
                >
                  Source : {values.source}
                </p>
              </div>
            </div>
          </div>
          <div className="w-full  px-5 md:px-10 my-3 md:my-10">
            <p className="font-roboto font-noraml text-grey-2000 text-sm">
              {' '}
              Is this your Current address?
            </p>
            <div className="w-full md:flex block py-3">
              <div className="flex-row-reverse flex md:flex-row ">
                <RadioButton
                  name="currentAddress"
                  value={values.currentAddress == 'yes' ? true : false}
                  checked={values.currentAddress == 'yes' ? true : false}
                  onChange={e => {
                    handleChange(e), setFieldValue('currentAddress', 'yes');
                  }}
                  onBlur={handleBlur}
                />
                <p className="font-roboto font-normal text-grey-2000 px-2 mr-auto">
                  Yes
                </p>
              </div>
              <div className="mr-auto flex md:ml-10 flex-row-reverse md:flex-row py-2 md:py-0">
                <RadioButton
                  name="currentAddress"
                  value={values.currentAddress == 'no' ? true : false}
                  checked={values.currentAddress == 'no' ? true : false}
                  onChange={e => {
                    handleChange(e), setFieldValue('currentAddress', 'no')
                  }}
                  onBlur={handleBlur}
                />
                <p className="font-roboto font-normal text-grey-2000 px-3 mr-auto">
                  No
                </p>
              </div>
            </div>
          </div>
          </>
               :
        <ResidentialStatus
          values={values}
          data={data}
          handleChange={handleChange}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
        />
                }

          
        </div>
      </div>

    </>
  );
};

export default ResidentialAdress;
